import { useI18n } from '@change-corgi/core/react/i18n';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { rewardBandit } from 'src/app/shared/api/bandits';
import { convertToUsdString } from 'src/app/shared/utils/currency';

export function useButtonBanditReward(): () => void {
	const utilityContext = useUtilityContext();
	const {
		data: {
			petition,
			currency: { exchangeRate },
		},
	} = usePromotePageData();
	const [{ amount }] = usePromotePageState();
	const { amountToBaseUnits } = useI18n();

	return () => {
		if (petition.bandits?.contextualPromotionButtons?.selectedVariant) {
			void rewardBandit(
				{
					experimentName: petition.bandits.contextualPromotionButtons.experimentName,
					variantName: petition.bandits.contextualPromotionButtons.selectedVariant.variantName,
					increment: amountToBaseUnits(parseFloat(convertToUsdString(amount, exchangeRate)), 'usd'),
				},
				utilityContext,
				{ silent: true },
			);
		}
	};
}
